import { createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteEstablishmentType } from "./establishmentTypeSlice";
import { ApiResponse } from "../../../types/APIResponse";
import api, {apiWithFormDataMethods} from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { EstablishmentType } from "../../../types";

// Async Thunks
export const fetchEstablishmentType = createAsyncThunk<EstablishmentType[], void, { rejectValue: string }>(
    'establishmentType/fetchEstablishmentType',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get<ApiResponse<EstablishmentType[]>>(apiEndpoints.establishmentType.getAll);
            return response.data; // Access the `data` field containing the categories
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch establishmentTypes');
        }
    }
);

export const addEstablishmentType = createAsyncThunk<EstablishmentType, { formData: FormData }, { rejectValue: string }>(
    'establishmentType/addEstablishmentType',
    async ({ formData }, { rejectWithValue }) => {
        try {
            const response = await apiWithFormDataMethods.post<ApiResponse<EstablishmentType>>(apiEndpoints.establishmentType.create, formData);
            return response.data; // Access the `data` field containing the created category
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to add establishmentType');
        }
    }
);

export const updateEstablishmentType = createAsyncThunk<EstablishmentType, { id: string; formData: FormData }, { rejectValue: string }>(
    'establishmentType/updateEstablishmentType',
    async ({ id, formData } , { rejectWithValue }) => {
        try {
            const response = await apiWithFormDataMethods.put<ApiResponse<EstablishmentType>>(`${apiEndpoints.establishmentType.update}/${id}`, formData );
            return response.data; // Access the `data` field containing the updated category
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to update establishmentType');
        }
    }
);

export const deleteEstablishmentType = createAsyncThunk<DeleteEstablishmentType, { id: string }, { rejectValue: string }>(
    'establishmentType/deleteEstablishmentType',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await api.delete<ApiResponse<DeleteEstablishmentType>>(`${apiEndpoints.establishmentType.delete}/${id}`);
            return { ...response.data, id }; // Access the `data` field containing the deleted category
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to delete establishmentType');
        }
    }
);

export const updateEstablishmentOrder = createAsyncThunk<EstablishmentType[], { orderUpdates: Array<{ id: string; index: number }> }, { rejectValue: string }>(
    "establishmentType/updateOrder",
    async ({ orderUpdates }, { rejectWithValue }) => {
        try {
            const response = await api.put<ApiResponse<EstablishmentType[]>>(apiEndpoints.establishmentType.updateOrder, { data: { orderUpdates } });
            if (response?.success) {
                return response.data;
            } else {
                throw new Error(response.message || "Failed to update establishmentType order");
            }
        } catch (error: any) {
            return rejectWithValue(error.message || "Failed to update establishmentType order");
        }
    }
);
